import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getSubscriptionsPageSideMenuItems } from './SubscriptionPageSideMenu';
import CommonLayout from './../CommonStructure/index';
import "./Subscription.css";
import ProfileInfo from "../../../Pages/Account/ProfileInfo";
import CompanyInfo from "../../../Pages/CompanyInfo";
import { Trash } from "lucide-react";
import { Billing, PricingPlans, ReferralProgram } from "../../../Pages";

const Subscriptions = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const tabParam = params.get("tab");
  const [activeKey, setActiveKey] = useState(tabParam || "1");

  const handleChangeSideMenu = ({ key }) => {
    setActiveKey(key);
  };

  const renderContent = () => {
    switch (activeKey) {
      case "1":
        return <PricingPlans />;
        case "2":
        return <Billing />;
      case "3":
        return <ReferralProgram />;
      default:
        return null;
    }
  };

  useEffect(() => {
    if (location.state?.activeTabKey) {
      setActiveKey(location.state.activeTabKey);
    }
  }, [location]);

  return (
    <div className="subscriptions-container">
      <CommonLayout
        sideMenuItems={getSubscriptionsPageSideMenuItems()}
        handleChangeSideMenu={handleChangeSideMenu}
        activeKey={activeKey}
      >
        {renderContent()}
      </CommonLayout>
    </div>
  );
};

export default Subscriptions;
